import { render, staticRenderFns } from "./DocumentTypeEntry.vue?vue&type=template&id=bae25344"
import script from "./DocumentTypeEntry.vue?vue&type=script&lang=js"
export * from "./DocumentTypeEntry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports